import request from '../utils/request';

/**
 * 小程序码 —— 可选页面路径列表（取自 xcx_menu）
 * 用于后台「选择菜单路径」下拉
 */
export const menuPaths = () => {
    return request({
        url: '/sys/xcxqrcode/menuPaths',
        method: 'post',
        data: {}
    });
};

/**
 * 生成小程序码
 * @param {Object} data { purpose, pagePath, menuId, scene, remark }
 */
export const generate = (data) => {
    return request({
        url: '/sys/xcxqrcode/generate',
        method: 'post',
        data
    });
};

/**
 * 小程序码列表（带菜单名 + 扫码次数）
 * @param {Object} data { pageIndex, pageSize, keyword, status }
 */
export const page = (data) => {
    return request({
        url: '/sys/xcxqrcode/page',
        method: 'post',
        data
    });
};

/**
 * 启用/停用
 * @param {Number} id
 * @param {Number} status 1启用 0停用
 */
export const setStatus = (id, status) => {
    return request({
        url: '/sys/xcxqrcode/setStatus',
        method: 'post',
        data: { id, status }
    });
};

/**
 * 逻辑删除
 * @param {Number} id
 */
export const delQrcode = (id) => {
    return request({
        url: '/sys/xcxqrcode/delete',
        method: 'post',
        data: { id }
    });
};
